module.exports = __webpack_public_path__ + "img/shili_cauthenticate1.a58025fb.png";